import { z } from 'zod';
export var CSSRSType = 'CSSRS';
export var SuicideAttemptResponse = z.object({
    checked: z.boolean().prefault(false),
    recent: z.boolean().prefault(false),
    description: z.string().prefault('')
});
export var InterruptedAttemptResponse = z.object({
    checked: z.boolean().prefault(false),
    recent: z.boolean().prefault(false),
    description: z.string().prefault('')
});
export var SelfInterruptedAttemptResponse = z.object({
    checked: z.boolean().prefault(false),
    recent: z.boolean().prefault(false),
    description: z.string().prefault('')
});
export var PreparatoryActsResponse = z.object({
    checked: z.boolean().prefault(false),
    recent: z.boolean().prefault(false),
    description: z.string().prefault('')
});
export var SelfHarmResponse = z.object({
    checked: z.boolean().prefault(false),
    recent: z.boolean().prefault(false),
    description: z.string().prefault('')
});
export var CSSRSBehavior = z.object({
    suicideAttempt: SuicideAttemptResponse,
    interruptedAttempt: InterruptedAttemptResponse,
    selfInterruptedAttempt: SelfInterruptedAttemptResponse,
    preparatoryActs: PreparatoryActsResponse,
    selfHarm: SelfHarmResponse
});
export var SuicidalIdeationType = z.enum([
    'NON_DISCLOSE',
    'WISH_TO_BE_DEAD',
    'GENERAL_SUICIDAL_IDEATION',
    'IDEATION_WITH_METHOD_WITHOUT_INTENT',
    'IDEATION_WITH_METHOD_WITH_INTENT',
    'IDEATION_WITH_INTENT_WITHOUT_PLAN',
    'IDEATION_WITH_PLAN_WITH_INTENT'
]);
export var NegativeEventResponse = z.object({
    checked: z.boolean().prefault(false),
    recent: z.boolean().prefault(false),
    description: z.string().prefault('')
});
export var IncarcerationOrHomelessnessResponse = z.object({
    checked: z.boolean().prefault(false),
    recent: z.boolean().prefault(false),
    description: z.string().prefault('')
});
export var LonelinessResponse = z.object({
    checked: z.boolean().prefault(false),
    recent: z.boolean().prefault(false),
    description: z.string().prefault('')
});
export var CSSRSActivatingEvents = z.object({
    negativeEvent: NegativeEventResponse,
    incarcerationOrHomelessness: IncarcerationOrHomelessnessResponse,
    loneliness: LonelinessResponse
});
export var PsychiatricResponse = z.object({
    checked: z.boolean().prefault(false),
    recent: z.boolean().prefault(false),
    description: z.string().prefault('')
});
export var HopelessnessResponse = z.object({
    checked: z.boolean().prefault(false),
    recent: z.boolean().prefault(false),
    description: z.string().prefault('')
});
export var NonComplianceResponse = z.object({
    checked: z.boolean().prefault(false),
    recent: z.boolean().prefault(false),
    description: z.string().prefault('')
});
export var NoTreatmentResponse = z.object({
    checked: z.boolean().prefault(false),
    recent: z.boolean().prefault(false),
    description: z.string().prefault('')
});
export var CSSRSTreatmentHistory = z.object({
    psychiatric: PsychiatricResponse,
    hopelessness: HopelessnessResponse,
    nonCompliance: NonComplianceResponse,
    noTreatment: NoTreatmentResponse
});
export var CSSRS = z.object({
    type: z.literal(CSSRSType),
    occurrenceDate: z.string().prefault(''),
    behavior: CSSRSBehavior,
    mostSevereIdeation: SuicidalIdeationType.prefault('NON_DISCLOSE'),
    activatingEvents: CSSRSActivatingEvents,
    treatmentHistory: CSSRSTreatmentHistory,
    otherRiskFactors: z.array(z.string()).prefault([]),
    clinicalStatus: z.array(z.string()).prefault([]),
    protectiveFactors: z.array(z.string()).prefault([]),
    otherProtectiveFactors: z.array(z.string()).prefault([])
}).prefault({
    activatingEvents: {
        incarcerationOrHomelessness: {
            checked: false,
            description: '',
            recent: false
        },
        loneliness: {
            checked: false,
            description: '',
            recent: false
        },
        negativeEvent: {
            checked: false,
            description: '',
            recent: false
        }
    },
    behavior: {
        interruptedAttempt: {
            checked: false,
            description: '',
            recent: false
        },
        preparatoryActs: {
            checked: false,
            description: '',
            recent: false
        },
        selfHarm: {
            checked: false,
            description: '',
            recent: false
        },
        selfInterruptedAttempt: {
            checked: false,
            description: '',
            recent: false
        },
        suicideAttempt: {
            checked: false,
            description: '',
            recent: false
        }
    },
    clinicalStatus: [],
    mostSevereIdeation: 'NON_DISCLOSE',
    occurrenceDate: '',
    otherProtectiveFactors: [],
    otherRiskFactors: [],
    protectiveFactors: [],
    treatmentHistory: {
        hopelessness: {
            checked: false,
            description: '',
            recent: false
        },
        noTreatment: {
            checked: false,
            description: '',
            recent: false
        },
        nonCompliance: {
            checked: false,
            description: '',
            recent: false
        },
        psychiatric: {
            checked: false,
            description: '',
            recent: false
        }
    },
    type: 'CSSRS'
});
